module.exports = __webpack_public_path__ + "img/basic-plan-icon.398f5824.svg";